// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridWidths } from "@insite/mobius/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import * as React from "react";
import { css } from "styled-components";

export interface SideMenuStyles {
    container?: InjectableCss;
    grid?: GridContainerProps;
    signInGridItem?: GridItemProps;
    separatorGridItem?: GridItemProps;
    separator?: TypographyProps;
    createGridItem?: GridItemProps;
}

type Props = WidgetProps;

const styles = {
    container: {},
    grid: {
        gap: 0,
        css: css`
            ${({ theme }) => gridGapStyles([], [theme.design.typography.spacing.large])}

            ${GridOffset} {
                justify-content: center;
            }
        `,
    },
    signInGridItem: {
        width: [12, 12, 6, 6, 5] as GridWidths[],
        css: css`
            justify-content: center;

            & > div {
                max-width: ${pxToRem(510)};
            }
        `,
    },
    separatorGridItem: {
        width: [12, 12, 2, 2, 2] as GridWidths[],
        css: css`
            position: relative;

            &::before {
                content: "";
                position: absolute;
                top: 50%;
                right: 0;
                left: 0;
                height: ${pxToRem(1)};
                background-color: ${getColor("common.border")};

                ${props =>
                    breakpointMediaQueries(
                        props.theme,
                        [
                            null,
                            null,
                            css`
                                top: 0;
                                right: auto;
                                bottom: 0;
                                left: 50%;
                                width: ${pxToRem(1)};
                                height: auto;
                            `,
                        ],
                        mediaOptions.min,
                    )}
            }
        `,
    },
    separator: {
        css: css`
            position: relative;
            margin: auto;
            background-color: ${getColor("common.background")};
            padding: 0 1em;
            font-size: ${({ theme }) => theme.design.typography.size.base};
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};

            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        null,
                        null,
                        css`
                            padding: 1em 0;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    createGridItem: {
        width: [12, 12, 5, 5, 5] as GridWidths[],
    },
};
export const signInStyles = styles;

const SignInView: React.FunctionComponent<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <GridContainer {...styles.grid}>
                <GridItem {...styles.signInGridItem}>
                    <Zone contentId={id} zoneName="Left" />
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SignInView,
    definition: {
        allowedContexts: ["SignInPage"],
        group: "Sign In",
        icon: "User",
        fieldDefinitions: [],
    },
};

export default widgetModule;
